const jQuery = require('jquery');


export function activateToast(classText) {
    jQuery('.' + classText).toast('show');
}
